// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecommendationRating {
  display: flex;
  align-items: center;
}
.RecommendationRating__Star {
  font-size: 24px;
  margin-right: 4px;
}
.RecommendationRating--High {
  color: rgba(0, 121, 107, 0.75);
}
.RecommendationRating--Medium {
  color: #f4c150;
}
.RecommendationRating--Low {
  color: #f44336;
}`, "",{"version":3,"sources":["webpack://./libs/features/property-recommendation/src/lib/PropertyRecommendationRating/PropertyRecommendationRating.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,iBAAA;AACJ;AAEE;EACE,8BAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,cAAA;AAFJ","sourcesContent":[".RecommendationRating {\n  display: flex;\n  align-items: center;\n\n  &__Star {\n    font-size: 24px;\n    margin-right: 4px;\n  }\n\n  &--High {\n    color: rgba(0, 121, 107, 0.75);\n  }\n\n  &--Medium {\n    color: #f4c150;\n  }\n\n  &--Low {\n    color: #f44336;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
